import { render, staticRenderFns } from "./WillStopEffect.vue?vue&type=template&id=349be3ab"
import script from "./WillStopEffect.vue?vue&type=script&lang=js"
export * from "./WillStopEffect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports